/**
 * 模块说明：大目录管理
 */
import { Service } from '@/tools'
export class BookServer<T extends TOrder.Bookmenu> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Bookmenu}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Bookmenu}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  /**
   * 功能：分页书单列表
   * /api/order/bookMenu/v1/page
   */
  bookPageList = <K extends T['ApiPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
     * 功能：新增
     * 
        /api/order/bookMenu/v1/bookMenuAdd
     */
  AddMethod = <K extends T['ApiBookMenuAdd']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuAdd', data)
  /**
     * 功能：编辑
     * 
     /api/order/bookMenu/v1/bookMenuUpdate
     */
  bookMenuUpdate = <K extends T['ApiBookMenuUpdate']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuUpdate', data)
  /**
     * 功能：书单详情
     * 
        /api/order/bookMenu/v1/bookMenuDetail
     */
  bookMenuDetail = <K extends T['ApiBookMenuDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuDetail', data)

  /**
     * 功能：书单恢复
     * 
      /api/order/bookMenu/v1/bookMenuRest
     */
  bookMenuRest = <K extends T['ApiBookMenuRest']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuRest', data)

  /**
     * 功能：查询所有生效书单
     * 
      /api/order/bookMenu/v1/bookMenuList
     */
  bookMenuList = <K extends T['ApiBookMenuList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuList', data)

  /**
     * 功能：查询所有生效书单
     * 
      /api/order/bookMenu/v1/bookList
     */
  bookList = <K extends T['ApiBookList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookList', data)

  /**
     * 功能：下发书单
     * 
      /api/order/bookMenu/v1/bookMenuIssue
     */
  bookMenuIssue = <K extends T['ApiBookMenuIssue']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuIssue', data)

  /**
     * 功能：书单明细商品行
     * 
      /api/order/bookMenu/v1/bookMenuDetailList
     */
  bookMenuDetailList = <K extends T['ApiBookMenuDetailList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuDetailList', data)
  /**
     * 功能：作废书单
     * 
   
/api/order/bookMenu/v1/bookMenuCancel
     */
  bookMenuCancel = <K extends T['ApiBookMenuCancel']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuCancel', data)
  /**
     * 功能：撤销下发书单
     * 
   
/api/order/bookMenu/v1/bookMenuCancelIssue
     */
  bookMenuCancelIssue = <K extends T['ApiBookMenuCancelIssue']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiBookMenuCancelIssue', data)

  /**
     * 功能：导入商品
     * 
   
/api/order/bookMenu/v1/importExcel
     */
  importExcel = <K extends T['ApiImportExcel']>(data?: K['req']): Promise<K['res']> => this.postUpload('v1/ApiImportExcel', data)

  /**
   * 功能： 书单选择器
   * /api/order/bookMenu/v1/bookListPage
   */
  bookListPage = <K extends T['ApiBookListPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBookListPage', data)



/**
 * 功能：商品选择器 通过skuId查询提供sku详情
 * /api/commodity/sku/v1/findSkuSpuDetailList
 */
findDetailList = <K extends T['ApifindDetailList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApifindDetailList', data, '操作成功')

  
}


